import { useQuery } from '@tanstack/react-query';
import { useAuth0 } from '@auth0/auth0-react';
import { isAxiosError } from 'axios';
import { getUserMineSDK } from '@/apis/admin-api';

export const useGetMySDKUser = () => {
  const { isAuthenticated } = useAuth0();

  return useQuery({
    queryKey: ['user_mine_sdk'],
    queryFn: getUserMineSDK,
    enabled: isAuthenticated,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      if (isAxiosError(error) && error.response?.status === 404) return false;
      return failureCount < 3;
    },
  });
};
